import BaseEntryPoint from './base_entry_point';
import { EventBus } from '../event_bus';
import { DataLoader } from '../data_loader';
import { TrackingManager } from 'analytics/tracking_manager';
import { ApiFactory } from '../api_factory';
import { PlayerFactory } from '../player_factory';
import { RenderingFactory } from '../rendering_factory';
import { AnnotationEngineFactory } from '../annotation_engine_factory';
import { APPLICATION_EVENT } from 'constants/events';

export default class Player extends BaseEntryPoint {
    initialize(options) {
        options.container.classList.add('hapyak-app');
        this.eventBus = new EventBus();
        this.dataLoader = new DataLoader(options, this.eventBus);
        this.tracking = new TrackingManager(options, this.eventBus);
        this.apis = ApiFactory.create(options, this.eventBus);

        const data = this.dataLoader.initialize(options.overrides);

        if (data) {
            this.data = options.data = data;
            PlayerFactory.create(options, this.eventBus)
                .then(adapter => {
                    this.playerAdapter = options.playerAdapter = adapter;
                    this.renderer = RenderingFactory.create(options, this.eventBus);
                    this.annotationEngine = AnnotationEngineFactory.create(options, this.eventBus);
                    this.eventBus.emit(APPLICATION_EVENT.LOAD, this.data);
                });
        }
    }

    get states() {
        return this.dataLoader?.stateEngine?.contextManager?.currentState || {};
    }
}